import { render, staticRenderFns } from "./AdminEdituserForm.vue?vue&type=template&id=0fbed85e&scoped=true"
import script from "./AdminEdituserForm.vue?vue&type=script&lang=js"
export * from "./AdminEdituserForm.vue?vue&type=script&lang=js"
import style0 from "./AdminEdituserForm.vue?vue&type=style&index=0&id=0fbed85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbed85e",
  null
  
)

export default component.exports